


import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageProvider";

export default function ImpressumPage({ showBackButton = false, onBack = null }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLanguage();

  const handleBack = () => {
    if (typeof onBack === "function") {
      onBack();
      return;
    }
    if (location.state?.from === "landing") {
      navigate("/landing");
      return;
    }
    navigate("/");
  };

  return (
    <div
      style={{
        width: "92%",
        margin: "0 auto",
        padding: "calc(18px + var(--vq-safe-area-top)) calc(16px + var(--vq-safe-area-right)) calc(28px + var(--vq-safe-area-bottom)) calc(16px + var(--vq-safe-area-left))",
        borderRadius: "16px",
        background: "rgba(255,255,255,0.04)",
        border: "1px solid rgba(255,255,255,0.10)",
        color: "white",
        boxSizing: "border-box",
      }}
    >
      {showBackButton && (
        <button
          onClick={handleBack}
          style={{
            background: "transparent",
            border: "1px solid rgba(255,255,255,0.2)",
            color: "#fff",
            padding: "10px 16px",
            borderRadius: "10px",
            cursor: "pointer",
            marginBottom: "30px",
            fontSize: "15px",
          }}
        >
          ← {t("common.back")}
        </button>
      )}

      <h1 style={{ marginTop: 0, fontSize: "clamp(22px, 5vw, 28px)", fontWeight: "800", marginBottom: "24px" }}>
  {t("impressum.title")}
</h1>

      <h2 style={{ fontWeight: "bold", marginTop: "20px" }}>
  {t("impressum.section5TMG")}
</h2>

      <p style={{ marginTop: "10px", lineHeight: "1.6" }}>
        Timon Eßer<br />
        Lessingstraße 14<br />
        77966 Kappel-Grafenhausen<br />
        Deutschland
      </p>

      <p style={{ marginTop: "10px", lineHeight: "1.6" }}>
        E-Mail: info@vaultquest.de
      </p>

      <h2 style={{ fontWeight: "bold", marginTop: "30px" }}>
  {t("impressum.contentResponsible")}
</h2>

      <p style={{ marginTop: "10px", lineHeight: "1.6" }}>
        Timon Eßer<br />
        Lessingstraße 14<br />
        77966 Kappel-Grafenhausen<br />
        Deutschland
      </p>

      <h2 style={{ fontWeight: "bold", marginTop: "30px" }}>
  {t("impressum.projectStatus")}
</h2>

      <p style={{ marginTop: "10px", lineHeight: "1.6" }}>
  {t("impressum.projectStatusText1")}
</p>

      <p style={{ marginTop: "10px", lineHeight: "1.6" }}>
  {t("impressum.projectStatusText2")}
</p>

      <p style={{ marginTop: "10px", lineHeight: "1.6" }}>
  {t("impressum.projectStatusText3")}
</p>

      <h2 style={{ fontWeight: "bold", marginTop: "30px" }}>
  {t("impressum.liabilityContentTitle")}
</h2>

      <p style={{ marginTop: "10px", lineHeight: "1.6" }}>
  {t("impressum.liabilityContentText1")}
</p>

      <p style={{ marginTop: "10px", lineHeight: "1.6" }}>
  {t("impressum.liabilityContentText2")}
</p>

      <h2 style={{ fontWeight: "bold", marginTop: "30px" }}>
  {t("impressum.liabilityLinksTitle")}
</h2>

      <p style={{ marginTop: "10px", lineHeight: "1.6" }}>
  {t("impressum.liabilityLinksText")}
</p>

      <h2 style={{ fontWeight: "bold", marginTop: "30px" }}>
  {t("impressum.copyrightTitle")}
</h2>

     <p style={{ marginTop: "10px", lineHeight: "1.6" }}>
  {t("impressum.copyrightText1")}
</p> 

      <p style={{ marginTop: "10px", lineHeight: "1.6" }}>
  {t("impressum.copyrightText2")}
</p>
    </div>
  );
}
